// hooks/useAuth.ts — Supabase session state (Google OAuth) (spec §4).
import { useCallback, useEffect, useState } from 'react';
import { useServices } from '../app/AppContext';
import type { AuthUser } from '../lib/supabase';

export interface UseAuth {
  user: AuthUser | null;
  loading: boolean;
  signIn: () => Promise<void>;
  signOut: () => Promise<void>;
}

export function useAuth(): UseAuth {
  const { auth } = useServices();
  const [user, setUser] = useState<AuthUser | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;
    auth
      .getUser()
      .then((u) => {
        if (active) {
          setUser(u);
          setLoading(false);
        }
      })
      .catch(() => active && setLoading(false));
    const unsub = auth.onChange((u) => setUser(u));
    return () => {
      active = false;
      unsub();
    };
  }, [auth]);

  const signIn = useCallback(() => auth.signInWithGoogle(`${window.location.origin}/app`), [auth]);
  const signOut = useCallback(() => auth.signOut(), [auth]);

  return { user, loading, signIn, signOut };
}
